import { FC } from "react";
import { twMerge } from "tailwind-merge";

import { BaseButton } from "./BaseButton";
import { TrackedLink } from "./TrackedLink";

import { t } from "i18n/i18n";
import { ScoreIcon } from "mds/icons";
import { type TrackingProps } from "utils/amplitude";

type OutcomeChipPropType = TrackingProps & {
  title: string;
  score?: number;
  selected?: boolean;
  to?: string;
  onClick?: () => void;
  className?: string;
  floor?: boolean;
  size?: "s" | "m";
  role?: "heading" | "listitem";
};

export const OutcomeChip: FC<OutcomeChipPropType> = ({
  score,
  title,
  to,
  onClick,
  size = "s",
  selected,
  className,
  eventName,
  floor = false,
  eventProps,
  role,
}) => {
  const hoverable = (to || onClick) && !selected;
  const chip = (
    <div
      className={twMerge(
        "flex w-max items-center gap-2.5 whitespace-nowrap rounded-full font-medium",
        size === "s" ? "px-2 py-1 text-sm" : "px-2.5 py-1.5 text-base",
        selected ? "bg-blue text-white" : "bg-blue-tint-95 text-blue-shade-20",
        hoverable && "cursor-pointer hover:bg-blue-tint-90",
        className,
      )}
    >
      <span aria-label={t("outcomes.outcome_label", { title })} role={role}>
        {title}
      </span>
      {score !== undefined && (
        <>
          {" "}
          <ScoreIcon
            aria-label={t("outcomes.average_score", { score })}
            floor={floor}
            role={role}
            size={size}
            value={score}
          />
        </>
      )}
    </div>
  );

  if (to) {
    return (
      <TrackedLink eventName={eventName} eventProps={eventProps} to={to} onClick={onClick}>
        {chip}
      </TrackedLink>
    );
  }

  if (onClick) {
    return (
      <BaseButton eventName={eventName} eventProps={eventProps} onClick={onClick}>
        {chip}
      </BaseButton>
    );
  }
  return chip;
};
